import { render } from "./UserFooter.vue?vue&type=template&id=a176124e"
import script from "./UserFooter.vue?vue&type=script&lang=js"
export * from "./UserFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__